
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/live-tv",
      function () {
        return require("private-next-pages/live-tv.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/live-tv"])
      });
    }
  